module.exports = __webpack_public_path__ + "img/hold.3e3a16b1.svg";